import { z } from 'zod';

export const aiPipelineSchema = z.object({
  top_n: z.number().int().min(1).max(10),
  confidence_floor: z.number().min(0).max(1),
  primary_locale: z.string(),
  locale_priorities: z.array(
    z.object({
      locale: z.string(),
      delay_seconds: z.number().int().min(0),
    }),
  ),
});

export const adminSchema = z.object({
  default_locale: z.string(),
  list_page_size: z.number().int().min(10).max(500),
});

export const SETTINGS_SCHEMAS = {
  ai_pipeline: aiPipelineSchema,
  admin: adminSchema,
} as const;

export type AiPipelineSettings = z.infer<typeof aiPipelineSchema>;
export type AdminSettings = z.infer<typeof adminSchema>;
